import React, { useState, useEffect } from "react";
import { Menu, X, Leaf } from "lucide-react";
import { Button } from "./ui/button";

const navLinks = [
  { label: "Home", href: "#home" },
  { label: "Why Act", href: "#why" },
  { label: "Priorities", href: "#priorities" },
  { label: "Awards", href: "#awards" },
  { label: "Nominate", href: "#nominate" },
  { label: "Jury", href: "#jury" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/85 backdrop-blur-md shadow-[0_2px_20px_rgba(15,42,32,0.08)]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between h-20">
        <a href="#home" className="flex items-center gap-2 group">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#1F5943] to-[#2D7A5F] flex items-center justify-center shadow-md group-hover:rotate-6 transition-transform duration-300">
            <Leaf className="w-5 h-5 text-white" strokeWidth={2.5} />
          </div>
          <div className="leading-none">
            <div className="font-display text-xl text-[#0f2a20] tracking-tight">
              multi<span className="text-[#2D7A5F]">-</span>omix
            </div>
            <div className="text-[10px] tracking-[0.2em] text-[#7a8b83] font-semibold mt-0.5">
              LIFE SCIENCES
            </div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm font-medium text-[#0f2a20] hover:text-[#1F5943] relative py-2 transition-colors"
            >
              <span>{l.label}</span>
              <span className="absolute left-0 right-0 -bottom-0.5 h-[2px] bg-[#1F5943] scale-x-0 group-hover:scale-x-100 transition-transform origin-left"></span>
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a href="#register" className="hidden md:inline-flex">
            <Button className="bg-[#1F5943] hover:bg-[#164031] text-white rounded-full px-6 h-11 font-semibold shadow-md hover:shadow-lg transition-all">
              Register Now
            </Button>
          </a>
          <button
            className="lg:hidden p-2 rounded-lg hover:bg-[#1F5943]/10 transition"
            onClick={() => setOpen(!open)}
            aria-label="menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-[#1F5943]/10 shadow-lg">
          <div className="px-6 py-4 flex flex-col gap-1">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="py-3 text-[#0f2a20] font-medium border-b border-[#1F5943]/5 last:border-0"
              >
                {l.label}
              </a>
            ))}
            <a href="#register" onClick={() => setOpen(false)}>
              <Button className="w-full mt-3 bg-[#1F5943] hover:bg-[#164031] text-white rounded-full h-11 font-semibold">
                Register Now
              </Button>
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
